import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { StaticGraphicConfig } from '@ui/tablo-generator/types';
import { TypedFormBuilder } from '@ui/form/TypedFormBuilder';
import { filter, tap } from 'rxjs/operators';
import { AliveState } from 'ZalamoLibrary/src/lib/core/ActiveState';

@Component({
    selector: 'lib-static-graphic-config',
    templateUrl: './static-graphic-config.component.html',
    styleUrls: ['./static-graphic-config.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StaticGraphicConfigComponent extends AliveState implements OnInit {
  selfUpdate = false;
  @Input() set currentConfig(config: StaticGraphicConfig) {
    this.selfUpdate = true;
    this.model.patchValue(config);
    this.selfUpdate = false;
  }
  @Output() updated = new EventEmitter<unknown>();
  model = this.fb.typedGroup<StaticGraphicConfig>({
    opacity: [0],
    hasColorOverlay: [false],
    colorOverlay: [''],
    hasShadow: [false],
    cssShadowFilter: [''],
  });
  constructor(private fb: TypedFormBuilder) {
    super();
  }

  ngOnInit(): void {
    this.subscribeWhileAlive(
      this.model.valueChanges.pipe(
        filter(() => !this.selfUpdate),
        tap((value) => this.updated.emit(value)),
      ),
    );
  }
}
